import styles from '../pagination.module.scss';

type Props = {
  reviewCount: string;
  totalCount: number;
  isPlanList: boolean;
};

const PaginationLabelComponent = (props: Props) => {
  const { reviewCount, totalCount, isPlanList } = props;

  const item = isPlanList ? 'プラン' : '件';
  const displayXItems = `${item}表示`;
  const outOfXItems = `${item}中`;

  return (
    <div className={styles.paginationLabelWrapper}>
      <div className={styles.paginationTotalWrapper}>
        <span className={styles.paginationTotal}>{totalCount}</span>
        <span>{outOfXItems}</span>
      </div>
      <div>
        {' '}
        {reviewCount} {displayXItems}{' '}
      </div>
    </div>
  );
};

export default PaginationLabelComponent;
